import enUS from './en-us'
import koKR from './ko-kr'

export default {
  'en-US': enUS,
  'ko-KR': koKR,
}
